import React, { useEffect } from 'react';
export function useSeoArticleScript(script, id, templateName) {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (templateName === 'Article' || templateName === 'Article Listicle Page') {
        const inlineScript = document.createElement('script');
        inlineScript.setAttribute('id', id);
        inlineScript.setAttribute('type', 'application/ld+json');
        inlineScript.innerHTML = script;
        document.body.append(inlineScript);
        return () => {
          inlineScript.remove();
        };
      }
    }
  }, []);
}
export const renderRTListSchema = list => {
  const schemaMap = JSON.stringify(list.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item
  })));
  const scriptContent = `{"@context": "https://schema.org","@type": "ItemList","itemListElement": ${schemaMap}}`;
  return /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: scriptContent
    }
  });
};
export const getListsTexts = dom => {
  if (!dom) return [];
  const rtLists = dom.querySelectorAll('ul, ol');
  const listValues = [];
  rtLists.forEach(list => {
    const listItemsForCurrentList = [];
    list.querySelectorAll('> li').forEach(li => {
      listItemsForCurrentList.push(li.text);
    });
    listValues.push(listItemsForCurrentList);
  });
  return listValues;
};